import { isPlatformNative } from 'src/lib/native/native.util';
import { AssignManualAbTestArgs } from 'src/replicant/ab/ab.modifiers';
import { analytics, isInLineMiniApp } from '@play-co/gcinstant';
import { GCInstant } from 'src/lib/gcinstant';
import { isPlatformLiff } from '../crossplay/crossplay.utils';
import { isNativeSupportLineLoginChannel } from 'src/conf/env';

/**
 * Get the arguments for the manual assign AB test function.
 * @returns
 */
export function getManualAssignAbTestArgs(): AssignManualAbTestArgs {
  // check to see if the game is running in demo mode
  const isDemoSubdomain =
    window.location.hostname.startsWith('demo.') ||
    window.location.pathname.includes('/dev/guest');

  // TODO: Remove this after all users are migrated over from 2.2.0 on IOS
  // This is a temporary fix for the issue where users on 2.2.0 on IOS would have issues after viewing ads
  // Ref: https://playcoinc.slack.com/archives/C04ALB20URL/p1701921292881209?thread_ts=1701919232.102749&cid=C04ALB20URL
  const nativeIOSVersion = analytics.getUserProperties()?.lastEntryAppleVersion;

  return {
    isPlatformNative: isPlatformNative(),
    isPlatformLiff: isPlatformLiff(),
    isNativeAndroid: GCInstant.osType === 'ANDROID_APP',
    isNativeIOS: GCInstant.osType === 'IOS_APP',
    isWebAndroid: GCInstant.osType === 'WEB_ANDROID',
    isInLineMiniApp: isInLineMiniApp(),
    nativeIOSVersion: nativeIOSVersion
      ? (nativeIOSVersion as string)
      : undefined,
    demoModeSubdomain: isDemoSubdomain,
    isNativeSupportLineLoginChannel: isNativeSupportLineLoginChannel(
      GCInstant.legacyNative,
    ),
  };
}
